export default {
  energy: "energy",
  transformation: "transformation",
  industrial: "industrial",
  training: "training"
};
